import {matchExpression, Variable} from '@packages/systems/wfdl';
import {identifier} from '@packages/systems/wfdl-Qualified';
import {constantFalse} from '@packages/utilities/fp/utils';

export const DYNAMO_VARIABLE = Variable.unqualified(identifier('Dynamo'));

export const isDynamoVariable = matchExpression({
  Variable: Variable.equals(DYNAMO_VARIABLE),
  _: constantFalse,
});
